import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk, RootState } from "./store";
import { setUserInfo, setUserToOrganization } from "./UserSlice";
import { setLoggedOrganization, setLoggedOrganizationId, setLoggedStatus, setLoggedType } from "./AuthSlice";
import { Api } from "../services/Api";
import { UserInfo } from "./UserSlice";
import { loadSession } from "../utils/session";
import CryptoJS from "crypto-js";
import { LinkGenerator } from "../models/Organization";

interface AppState {
}

const initialState: AppState = {
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
    }
  });
  
export const {} = appSlice.actions;

// customs func
export const checkUserLogged = () : AppThunk<Promise<boolean>> => async (dispatch) => {

    const userInfo = loadSession<UserInfo>();
    if (!userInfo) return false;

    Api.setUserInfo(userInfo);
    dispatch(setLoggedStatus(true));
    dispatch(setLoggedType(userInfo.role));
    dispatch(setUserInfo(userInfo))
    return true;

}

export const checkLinkInvite = (url:string) : AppThunk<Promise<boolean>> => async (dispatch, getState) => {

    const state  = getState();
    const userId = state.user.userInfo?.id;

    // Precisa de um usuario logado valido — senao o vinculo iria para userId=0.
    if (!url || !userId) return false;

    try {
        const inviteEncoded = url.split("key=")[1];
        if (!inviteEncoded) return false;

        const invite = decodeURIComponent(inviteEncoded);
        const bytes = CryptoJS.AES.decrypt(invite, state.auth.secretKey);
        const inviteDecrypt = bytes.toString(CryptoJS.enc.Utf8);

        // O link traz { orgId, fee } definidos pela empresa para esse cliente.
        const data : LinkGenerator = JSON.parse(inviteDecrypt);

        await dispatch(setUserToOrganization({
            userId,
            orgId: data.orgId,
            fee:   data.fee,
        }));

        return true;
    } catch (e) {
        console.error('checkLinkInvite: convite invalido ou ja processado', e);
        return false;
    }
}

export default appSlice.reducer;